import React, { useState, useEffect } from "react";
import { Form, Button, Row, Col, Table, Modal } from "react-bootstrap";
import MoveUpIcon from "@mui/icons-material/MoveUp";
import RowCountLabel from "./RowCountLabel";
import ApiManager from "../utils/ApiManager";

import LinkIcon from "@mui/icons-material/Link";
import UnLinkIcon from "@mui/icons-material/LinkOff";

//import ModalMoveProducts from "./ModalMoveProducts";
//import ProductSearch from "./ProductSearch";
//import ProductLink from "./ProductLink";

import WireTransferSearch from "./WireTransferSearch";
// import ModalSearchOrder from "./ModalSearchOrder";

import DataManager from "../utils/DataManager";

const WireTransfers = () => {
  // const [selectedWireTransferTxid, setSelectedWireTransferTxid] = useState("");

  const [lastTxIds, setLastTxIds] = useState([]);

  const [data, setData] = useState([]);
  const [filters, setFilters] = useState(null);
  const [loading, setLoading] = useState(false);

  // const [modalSearchOrder, setModalSearchOrder] = useState({ showModal: false });
  
  useEffect(() => {
    if (filters != null) {
      fetchWireTransfers(); 
    }   
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters]);

  const fetchWireTransfers = () => {
    setLoading(true);
    ApiManager.Top.wiretransfers(
      { ...filters, last: JSON.stringify(lastTxIds)},
      (data) => {
        setLoading(false);
        setData(data || []);
      },
      (error) => {
        setLoading(false);
        console.error("Error fetching wiretransfers:", error);
      },
      () => {}
    );
  };
  
  const handleFiltersChange = (filters) => {
    setLastTxIds([]);
    setFilters(filters);
  }

  const handleCheckboxChange = (TxId) => {
    setLoading(true);
    ApiManager.Top.wiretransfersCheck(
      {
        TxId: TxId
      },
      (data) => {
        if (lastTxIds.indexOf(TxId) == -1) {
          lastTxIds.push(TxId);
        }
        setLoading(false);
        setFilters({ ...filters });
      },
      (error) => {
        setLoading(false);
        console.error("Error fetching wiretransfer check:", error);
      },
      () => {}
    );
  }

  // const closeModalSearchOrder = () => {
  //   setModalSearchOrder({ showModal: false });
  // }

  // // open modal
  // const onLink = (TxId, AddtlTxInf) => {
  //   setModalSearchOrder({ showModal: true, title: AddtlTxInf, onCloseModal: closeModalSearchOrder });
  // }

  // open modal
  const onUnLink = (TxId, AddtlTxInf) => {
  //   setModalLink({ open: true, addtlTxInf: AddtlTxInf, cartid: "" });
  }

  let all = (data || []).map((s, i) => {
    return (
    <tr key={"row-" + i}>
      <td>
        <Form.Check 
          type="checkbox"
          label=""
          checked={(s.ConfirmedOn || null) != null ? true : false}
          onChange={e => handleCheckboxChange(s.TxId)}
          className="large-checkbox"
        />
      </td>
      <td style={{opacity: s.Status === "CHECKED" ? "0.5" : "1", "color": s.Status === "ERROR" ? "red" : ""}}>
        {s.AddtlTxInf}<br/>
        <span style={{fontSize: "10px"}}>{s.DbtrIban}</span>
      </td>
      <td style={{textAlign: "right", opacity: s.Status === "CHECKED" ? "0.5" : "1", "color": s.Status === "ERROR" ? "red" : ""}}>{DataManager.Decimal.format(s.Amt)} {s.AmtCcy}</td>
      <td style={{opacity: s.Status === "CHECKED" ? "0.5" : "1", "color": s.Status === "ERROR" ? "red" : ""}}>{DataManager.Date.format(s.ValDt, 'dd/MM/yyyy')}</td>
      <td style={{opacity: s.Status === "CHECKED" ? "0.5" : "1", "color": s.Status === "ERROR" ? "red" : ""}}><div title={s.Message}>{s.Status === "CHECKED" ? "Spuntato" : (s.Status === "NONE" ? "Non spuntato" : "In errore")}</div></td>
      {/* <td>
        {(s.CartId || "") == "" ? 
        <button className="btn btn-sm btn-link pr-0"
              onClick={e => onLink(s.TxId, s.AddtlTxInf)}
        >
          <LinkIcon/>
        </button>
        : 
        <div>
          s.CartId <button className="btn btn-sm btn-link pr-0"
                            onClick={e => onUnLink(s.TxId, s.AddtlTxInf)}
                    >
            <UnLinkIcon/>
          </button>
        </div>}
      </td> */}
    </tr>
    );
  });

  return (
    <div className="wiretransfers">
      <WireTransferSearch
        onFiltersChange={handleFiltersChange}
        setLoading={setLoading}
      />
      <Row className="mb-3">
        <Col>
          <Table striped>
            <thead>
              <tr>
                <th style={{ width: "32px", textAlign: "center" }}>&nbsp;</th>
                <th>DESCRIPTION</th>
                <th style={{ width: "128px", textAlign: "right" }}>AMOUNT</th>
                <th style={{ width: "128px" }}>DATE</th>
                <th style={{ width: "128px" }}>STATUS</th>
                {/* <th style={{ width: "128px" }}>CART&nbsp;ID</th> */}
              </tr>
            </thead>
            <tbody>    
              {all}
            </tbody>
          </Table>
        </Col>
      </Row>
      {/* <ModalSearchOrder
        modalData={modalSearchOrder}
      /> */}
      <Modal show={loading} backdrop="static" keyboard={false} centered>
        <Modal.Body className="text-center">
          <div className="spinner-border" />
          <p>Attendere...</p>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default WireTransfers;
